// Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
export const firebaseConfig = {
  "apiKey": null,
  "authDomain": null,
  "databaseURL": null,
  "projectId": null,
  "storageBucket": null,
  "messagingSenderId": null,
  "appId": null,
};
